import gql from 'graphql-tag';

export const GET_ALL_SEO_LANDING_PAGES = gql`
query PageQuery($publicationState: PublicationState!) {
  seoLandingPages(publicationState: $publicationState) {
    MetaTagSection {
      name
      content
    }
    titleOfTheBrowser
    uid
    prefixUid
    pageUrl
    pageStyle
    titleOfTheBrowser
    articleTemplate {
      breadcrumbs
    }
    headerTemplate {
      copy
      heading1
      ctas {
        url
        behavior
        label
        contentUid
        Uid
      }
      headerMedia {
        small {
          url
          webPURL
        }
        medium {
          url
          webPURL
        }
        large {
          url
          webPURL
        }
      }
    }
    elements {
      __typename
      ... on ComponentElementsGenericComponent {
        ...genericcontents
      }
      ... on ComponentElementsGlobalComponent {
        ...globalContents
        genericComponent {
          ...genericcontents
        }
      }
    }
    hero_banner {
      ...heroContents
    }
    custom_header {
      ...customHeaderContent
    }
  }
}

fragment heroContents on HeroBanner {
  uid
  BackgroundColour
  FlareType
  BannerType
  ButtonColour
  ButtonStyle
  ButtonSize
  CopyStyle
  backgroundMedia {
    small {
      url
    }
    medium {
      url
    }
    large {
      url
    }
  }
}

fragment customHeaderContent on CustomHeader {
  Uid
  headerMedia {
    backgroundColour
  }
  logo {
    alt
    copy
    media {
      url
      webPURL
      previewUrl
    }
  }
}
fragment globalContents on ComponentElementsGlobalComponent {
  Globaltype: type
  id
  title
  copy
  contentSectionID
  globalElementType {
    title
    uid
  }
}

fragment genericcontents on ComponentElementsGenericComponent {
  id
  uid
  externalUrl
  type
  title
  subtitle
  copy
  background_colour {
    colour {
      Name
    }
  }
  genericElementType {
    title
    uid
  }
  icon {
    url
    webPURL
  }
  media {
    copy
    alt
    URL
    media {
      id
      url
      webPURL
      previewUrl
    }
    backupMedia {
      id
      url
      previewUrl
    }
  }
  ctas {
    url
    label
    contentUid
    behavior
    icon_class
    targetNewPage
    targetContentSectionID
    Uid
  }
  listOfContent {
    text
    content
  }
  listOfLinks {
    links {
      id
      label
      url
    }
  }
  matrix {
    image_size
    Column {
      ColumnTitle
      Row {
        RowText
      }
      Media {
        url
      }
    }
  }
  legal_terms {
    heading
    content
    listOfContent {
      text
      content
    }
  }
  ordered_legal_terms {
    legal_term {
      heading
      content
      listOfContent {
        text
        content
      }
    }
  }
  tv_bundles {
    title
    tv_sections {
      title
      channels {
        title
        logo {
          url
        }
      }
    }
  }
  ordered_tv_bundles {
    ordered_tv_bundle {
      title
      ordered_sections {
        ordered_tv_section {
          title
          ordered_channels {
            tv_channel {
              title
              logo {
                url
              }
            }
          }
        }
      }
    }
  }
  products {
    product_id
  }
  ordered_products {
    product {
      product_id
      placeholder_and_image {
        Placeholder {
          media {
            url
          }
        }
        Image {
          media {
            url
          }
        }
      }
    }
  }
  KeyValue {
    id
    key
    uuid
    value {
      id
      value
      uuid
    }
  }
  fa_icon_name
  fa_icon_color
  fa_icon_weight
}
`;

export const GET_ALL_FAULT_ARTICLES = gql`
query PageQuery($publicationState: PublicationState!) {
  faultArticles(publicationState: $publicationState) {
    titleOfTheBrowser
    uid
    elements {
      __typename
      ... on ComponentElementsGlobalComponent {
        ...globalContents
        genericComponent {
          ...genericcontents
        }
      }
    }
  }
}

fragment globalContents on ComponentElementsGlobalComponent {
  Globaltype: type
  title
  copy
  contentSectionID
  globalElementType {
    title
    uid
  }
}

fragment genericcontents on ComponentElementsGenericComponent {
  uid
  externalUrl
  type
  title
  subtitle
  copy
  background_colour {
    colour {
      Name
    }
  }
  genericElementType {
    title
    uid
  }
  icon {
    url
    webPURL
  }
  media {
    copy
    alt
    URL
    media {
      id
      url
      webPURL
      previewUrl
    }
    backupMedia {
      id
      url
      previewUrl
    }
  }
  ctas {
    url
    label
    contentUid
    behavior
    icon_class
    targetNewPage
    targetContentSectionID
    Uid
  }
  listOfContent {
    text
    content
  }
  listOfLinks {
    links {
      label
      url
    }
  }
  KeyValue {
    key
    uuid
    value {
      id
      value
      uuid
    }
  }
  fa_icon_name
  fa_icon_color
  fa_icon_weight
}
`;

export const GET_ALL_SEO_LANDING_PAGES_SCULLY_URLS = gql`
query PageQuery($publicationState: PublicationState!) {
  seoLandingPages(publicationState: $publicationState) {
    pageUrl
  }
}
`;

export const GET_ALL_SEO_LANDING_PAGE_BY_UID_PREFIX = gql`
query PageQuery($pageuid: [ID!]!, $prefixUid: String, $publicationState: PublicationState!) {
  seoLandingPages(
    where: { uid_in: $pageuid, prefixUid_in: ["", $prefixUid] }
    publicationState: $publicationState
  ) {
    MetaTagSection {
      name
      content
    }
    titleOfTheBrowser
    uid
    prefixUid
    pageUrl
    pageStyle
    titleOfTheBrowser
    articleTemplate {
      breadcrumbs
    }
    headerTemplate {
      copy
      heading1
      ctas {
        url
        behavior
        label
        contentUid
        Uid
      }
      headerMedia {
        small {
          url
          webPURL
        }
        medium {
          url
          webPURL
        }
        large {
          url
          webPURL
        }
      }
    }
    elements {
      __typename
      ... on ComponentElementsGenericComponent {
        ...genericcontents
      }
      ... on ComponentElementsGlobalComponent {
        ...globalContents
        genericComponent {
          ...genericcontents
        }
      }
    }
    hero_banner {
      ...heroContents
    }
    custom_header {
      ...customHeaderContent
    }
  }
}

fragment heroContents on HeroBanner {
  uid
  BackgroundColour
  FlareType
  BannerType
  ButtonColour
  ButtonStyle
  ButtonSize
  CopyStyle
  backgroundMedia {
    small {
      url
    }
    medium {
      url
    }
    large {
      url
    }
  }
}

fragment customHeaderContent on CustomHeader {
  Uid
  headerMedia {
    backgroundColour
  }
  logo {
    alt
    copy
    media {
      url
      webPURL
      previewUrl
    }
  }
}
fragment globalContents on ComponentElementsGlobalComponent {
  Globaltype: type
  id
  title
  copy
  contentSectionID
  globalElementType {
    title
    uid
  }
}

fragment genericcontents on ComponentElementsGenericComponent {
  id
  uid
  externalUrl
  type
  title
  subtitle
  copy
  background_colour {
    colour {
      Name
    }
  }
  genericElementType {
    title
    uid
  }
  icon {
    url
    webPURL
  }
  media {
    copy
    alt
    URL
    media {
      id
      url
      webPURL
      previewUrl
    }
    backupMedia {
      id
      url
      previewUrl
    }
  }
  ctas {
    url
    label
    contentUid
    behavior
    icon_class
    targetNewPage
    targetContentSectionID
    Uid
  }
  listOfContent {
    text
    content
  }
  listOfLinks {
    links {
      id
      label
      url
    }
  }
  matrix {
    image_size
    Column {
      ColumnTitle
      Row {
        RowText
      }
      Media {
        url
      }
    }
  }
  legal_terms {
    heading
    content
    listOfContent {
      text
      content
    }
  }
  ordered_legal_terms {
    legal_term {
      heading
      content
      listOfContent {
        text
        content
      }
    }
  }
  tv_bundles {
    title
    tv_sections {
      title
      channels {
        title
        logo {
          url
        }
      }
    }
  }
  ordered_tv_bundles {
    ordered_tv_bundle {
      title
      ordered_sections {
        ordered_tv_section {
          title
          ordered_channels {
            tv_channel {
              title
              logo {
                url
              }
            }
          }
        }
      }
    }
  }
  products {
    product_id
  }
  ordered_products {
    product {
      product_id
      placeholder_and_image {
        Placeholder {
          media {
            url
          }
        }
        Image {
          media {
            url
          }
        }
      }
    }
  }
  KeyValue {
    id
    key
    uuid
    value {
      id
      value
      uuid
    }
  }
  fa_icon_name
  fa_icon_color
  fa_icon_weight
}
`;

export const GET_ALL_DASHBOARD_ARTICLES = gql`
query PageQuery($publicationState: PublicationState!) {
  faultArticles(
    where: { id_gte: 1000 }
    publicationState: $publicationState
  ) {
    titleOfTheBrowser
    uid
    elements {
      __typename
      ... on ComponentElementsGlobalComponent {
        ...globalContents
        genericComponent {
          ...genericcontents
        }
      }
    }
  }
}

fragment globalContents on ComponentElementsGlobalComponent {
  Globaltype: type
  title
  copy
  contentSectionID
  globalElementType {
    title
    uid
  }
}

fragment genericcontents on ComponentElementsGenericComponent {
  uid
  externalUrl
  type
  title
  subtitle
  copy
  background_colour {
    colour {
      Name
    }
  }
  genericElementType {
    title
    uid
  }
  icon {
    url
    webPURL
  }
  media {
    copy
    alt
    URL
    media {
      id
      url
      webPURL
      previewUrl
    }
    backupMedia {
      id
      url
      previewUrl
    }
  }
  ctas {
    url
    label
    contentUid
    behavior
    icon_class
    targetNewPage
    targetContentSectionID
    Uid
  }
  listOfContent {
    text
    content
  }
  listOfLinks {
    links {
      label
      url
    }
  }
  KeyValue {
    key
    uuid
    value {
      id
      value
      uuid
    }
  }
  fa_icon_name
  fa_icon_color
  fa_icon_weight
}
`;
